import React from "react";
import { Tabs } from "antd";
import SkimList from "../../components/setting-conponents/ProductType/SkimList";
import LatexList from "../../components/setting-conponents/ProductType/LatexList";
import AddLatexModal from "../../components/setting-conponents/ProductType/AddLatexModal";
import AddSkimModal from "../../components/setting-conponents/ProductType/AddSkimModal";

export default function ProductTypeSettingView() {
  const [activeTab, setActiveTab] = React.useState("latex");
  const [openAddSkimList, setOpenAddSkimList] = React.useState(false);
  const [openAddLatexList, setOpenAddLatexList] = React.useState(false);

  const tableRef = React.useRef(null);

  const items = [
    {
      key: "latex",
      label: "สินค้าน้ำยางข้น",
      children: <LatexList isDone={false} ref={tableRef} />,
    },
    {
      key: "skim",
      label: "สินค้าสกิม",
      children: <SkimList isDone={false} ref={tableRef} />,
    },
  ];

  const refreshData = async () => {
    if (tableRef.current) {
      await tableRef.current.fetchTable();
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="latex"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        style={{ marginTop: 15 }}
      />
      <AddLatexModal 
        open={openAddLatexList}
        onClose={() => setOpenAddLatexList(false)}
        onUpdate={() => {
          setOpenAddLatexList(false);
          refreshData();
        }}
        target={null}
      />
      <AddSkimModal
        open={openAddSkimList}
        onClose={() => setOpenAddSkimList(false)}
        onUpdate={() => {
          setOpenAddSkimList(false);
          refreshData();
        }}
        target={null}
      />
    </div>
  );
}
